import { useState, useEffect, useCallback } from 'react';
import { DateRangePickerDialog, ToolbarButton, UserInterfaceCalendar, getStaticRanges, Button } from 'neon-design-system';
import { RangeKeyDict, Range } from 'react-date-range';
import { localDateFormat } from '../../utils/date';

interface Props {
  selectedRanges: Range[];
  onChange: (rangesByKey: RangeKeyDict) => void;
}

export const ToolbarDatePicker = ({ selectedRanges, onChange }: Props) => {
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState('Last 7 days');
  const defaultRangeItems = getStaticRanges().map((range) => ({ title: range.label!, value: range.label! }));
  const [items, setItems] = useState<{ title: string; value: string }[]>(defaultRangeItems);
  const [ranges, setRanges] = useState<Range[]>(selectedRanges);

  const handleClose = useCallback(() => {
    setRanges(selectedRanges);
    setOpen(false);
  }, [selectedRanges]);

  useEffect(() => {
    const isStaticRangeSelected = getStaticRanges().find((staticRange) => staticRange.isSelected(ranges[0]));
    if (isStaticRangeSelected) {
      setLabel(isStaticRangeSelected.label!);
    } else {
      const selectedRangeLabel = `${localDateFormat(ranges[0].startDate!, false)} - ${localDateFormat(ranges[0].endDate!, false)}`;
      const updatedItems = [...items];
      updatedItems.push({ title: selectedRangeLabel, value: selectedRangeLabel });
      setItems(updatedItems);
      setLabel(selectedRangeLabel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRanges]);

  return (
    <>
      <ToolbarButton icon={<UserInterfaceCalendar />} id="dateRangePickerButton" text={label} onClick={() => setOpen(true)} />
      <DateRangePickerDialog
        title="Custom date range"
        open={open}
        handleClose={handleClose}
        dateRangePickerProps={{
          ranges,
          onChange: (item) => setRanges([item.selection]),
          minDate: new Date(2022, 0, 1),
          maxDate: new Date()
        }}
      >
        <>
          <Button colorType="grey" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            colorType="primary"
            onClick={() => {
              onChange({ selection: ranges[0] });
              setOpen(false);
            }}
          >
            Confirm selection
          </Button>
        </>
      </DateRangePickerDialog>
    </>
  );
};
